<script>
import VirtualTableCell from './VirtualTableCell.vue';
import { shouldGrowColumn } from '../services/columnWidthCalculator';

export default {
    components: {
        VirtualTableCell
    },
    props: {
        rowIndex: {
            type: Number,
            required: true
        },
        item: {
            type: Object,
            default: null
        },
        isPlaceholder: {
            type: Boolean,
            required: true
        },
        headers: {
            type: Array,
            required: true
        },
        columnWidths: {
            type: Object,
            required: true
        },
        cellHeight: {
            type: Number,
            required: true
        },
        clickable: {
            type: Boolean,
            default: false
        },
        scopedSlots: {
            type: Object,
            default: () => ({})
        }
    },
    methods: {
        shouldGrowColumn,
        handleCellClick() {
            if (!this.isPlaceholder && this.item && this.clickable === true) {
                this.$emit('cell-click', { item: this.item });
            }
        }
    },
    render(h) {
        const cells = this.headers.map((header, index) => {
            const slotName = `cell.${header.value}`;
            const hasSlot = this.scopedSlots && this.scopedSlots[slotName];

            // Determine cell content
            let cellContent;
            if (!this.isPlaceholder && hasSlot) {
                // Use the custom scoped slot
                cellContent = this.scopedSlots[slotName]({ item: this.item });
            } else if (!this.isPlaceholder && header.value !== 'actions') {
                // Fallback to plain value
                cellContent = this.item ? String(this.item[header.value] ?? '') : '';
            }

            return h('virtual-table-cell', {
                key: header.value,
                props: {
                    column: header.value,
                    value: header.value === 'actions' ? null : (this.item ? this.item[header.value] : null),
                    align: header.align,
                    width: this.columnWidths[header.value],
                    isLast: index === this.headers.length - 1,
                    shouldGrow: shouldGrowColumn(index, this.headers),
                    height: this.cellHeight,
                    isPlaceholder: this.isPlaceholder
                },
                on: {
                    click: this.handleCellClick
                }
            }, cellContent !== undefined ? (Array.isArray(cellContent) ? cellContent : [cellContent]) : undefined);
        });

        return h('div', {
            class: {
                'table-row': true,
                'table-row--even': this.rowIndex % 2 === 0
            }
        }, cells);
    }
};
</script>

<style scoped>
.table-row {
    display: flex;
    width: 100%;
}

.table-row--even {
    background-color: rgba(0, 0, 0, 0.05);
}
</style>
